// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__J1AsG","legacyBtn":"MutateMid_legacyBtn__7iV6f"};